import { DependentData } from "@features/pages/collection/interface/collection-iterface";
import { DescriptionModelConfig, ModelGalleryConfig, ModelGallerySelectedData, UploadModelConfig } from "@features/pages/dashboard/interface/dashboard-interface";
import { ActionButton, BomRow, Page, TechPackFeatures, TechPackItem } from "@features/pages/techpack/interface/feature-data.interface";
import { TableColumn } from "@shared/components/custom/table/table";
import { HeaderData } from "./header";
import { IconCategory, IconChild, SettingsFormat } from "./icon-category";

// EventMap: define your static, compile-time events here.
export interface EventMap {
    //   USER_UPDATED: { userId: string; name: string };
    //   CART_CHANGED: { totalItems: number };
    //   THEME_CHANGED: { mode: 'light' | 'dark' };
    DASHBOARD_IMAGE_LIST: {},
    ICONSELECTED: { selectedItem: IconCategory | null, selectedChild: IconChild | null, featureId?: string | number | null },
    GETICONFEATURES: { parent_id: string, parent_value: string, selected_value?: string },
    GETSUBFEATURES: { parent_id: string, parent_value: string, selected_value?: string },
    // GETICONFEATURESINNER: { parent_id: string, parent_value: string },
    FEATURELISTSELECTED: Record<string, number | string> | null,
    SUBFEATURELISTSELECTED: Record<string, number | string> | null,
    GETFEATUREFORMDATA: { errorObject: { error: boolean, message: string }, params: Record<string, number | string | File | File[] | null> | null },
    GETFORMSETTINGDATA: { errorObject: { error: boolean, message: string }, params: Record<string, number | string | File | File[] | null> | null },
    CLEAR_FIELDS: {},
    FEATURES_AVAILABLE: boolean,
    AUTOTABSLIST: {},
    NUDGING_DATA: DependentData | null,
    GENERATE_CLICKED: { error: boolean, message: string, field?: string },
    GETCREDITDATA: { credit: number },
    UPDATECREDITDATA: {},
    UPDATEFORMATDATA: SettingsFormat,
    GETTECHPACKCONFIG: {},
    GETTECHAPCKDATA: Partial<{ fabric: string | number | null, garment: string | number | null, stretch: string | number | null }>
    ADD_TO_TECHPACK: TechPackItem,
    GET_GARMENT_TYPE: string | number | null,
    TECHPACK_PDF: File | null,
    SAVED_TECHPACK: { buttons: ActionButton[] | null, data: Record<string, number | string | File | File[] | null | Date> | null, pagedata: Page[], pageId?: string, clear?: boolean, changeUrl?: boolean } | null,
    ADD_TECHPACK: { action: string, data: Record<string, number | string | File | File[] | null | Date> | null },
    GET_FILE: File | null,
    REFRESH_TECHPACK_LIST: string,
    GET_FORM_DATA: Record<string, number | string | File | File[] | null | Date> | null,
    GET_HEADER_DATA: HeaderData,
    CURRENT_TAB: { tab: string | number, subTab: string | number },
    USER_LOGGED_OUT: {},
    TECHPACK_TAB_CHANGE: 'auto' | 'manual',
    TECHPACK_TEMPLATE_SELECTED: { data: boolean, saved?: boolean },
    TECHPACK_GET_CANVAS_FILE: null,
    TECHPACK_CANVAS_FILE: { file: File | null, loader: boolean },
    TECHPACK_ANNOTATION_IDS: { auto: string | number, manual: string | number, list: { id: string | number, name: string, lov_metadata?: any, isAccess?: number }[] },
    TECHPACK_GENERATED_IMAGE: { url: string, mongo_id: string, image_key: string, format: string, id: number, headers?: TableColumn<BomRow>[], pdfHeaders?: TableColumn<BomRow>[], value?: BomRow[], change?: boolean } | null,
    MANUAL_UNLOCK: boolean,
    MANUAL_EDIT_STARTED: boolean,
    SUB_TAB_CHANGE: { tab: string | number, subTab: string | number, isNew?: 1 | 0 },
    DOWNLOAD_TYPE: string;
    TECHPACK_ID: number;
    TECHPACK_FEATURE_TYPE: TechPackFeatures;
    UPDATEVIEWDATA: { id: number | string, name: string },
    UPDATEVIEWVISIBILITY: { showView: boolean },
    ANNOTATION_ID: { id: number | string, name: string };
    TECHPACK_SAVED: {};
    // NEW EVENT ADDED HERE:
    SYNC_GARMENT_TYPE: string | number;
    GARMENT_LIST_FILTER: { id: string | number; name: string }[] | null;
    TEMPLATE_GALLERY_FILTER_SYNC: { dress_type: string; gender_type: string; view_type: string; category_id: string } | null;
    TECHPACK_IMAGE_LIST: {};
    PAGE_ID: number;
    SELECTED_GALLEY_DATA: ModelGallerySelectedData;
    MODEL_GALLERY_REFRESH: Record<string, number | string> | null;
    TOGGLE_MODEL_GALLERY: { flag: boolean, modelConfig: ModelGalleryConfig, uploadImageConfig: UploadModelConfig, descriptionModel: DescriptionModelConfig }
    OPEN_PEN_TOOL: { show: boolean; imageUrl?: string; template?: TechPackItem | null, file?: File | null; },
    PEN_TOOL_SAVED: { file: File; dataUrl: string },
    AI_Table_INFINITE_SCROLL: {},
    TEMP_LOGO: {files: File[] | null, key: string},
}


// Typed packet for keys from EventMap
export interface EventPacket<K extends keyof EventMap = keyof EventMap> {
    type: K;
    payload: EventMap[K];
}

// Union of all typed packets
export type EventPacketUnion = {
    [K in keyof EventMap]: EventPacket<K>;
}[keyof EventMap];

// Generic dynamic packet for runtime events
export interface DynamicEventPacket<T = unknown> {
    type: string;         // arbitrary runtime key
    payload: T;
}

// Type guard to narrow EventPacketUnion by key K
export function isEventOfType<K extends keyof EventMap>(
    event: EventPacketUnion | DynamicEventPacket<unknown>,
    type: K
): event is EventPacket<K> {
    // event might be dynamic; check both structure and type equality
    return (event as EventPacketUnion).type === type;
}
